import React from "react";

export default function ErpIdeal() {
    return (
        <div className="w-full bg-[url(../assets/cover-proposito.png)] py-24 relative overflow-hidden text-white">
            <div className="max-w-[1200px] mx-auto relative z-10 px-4 md:px-8 flex flex-col items-center justify-center">
                <h2 className="font-inter-light text-4xl md:text-5xl lg:text-6xl text-center mb-4">
                    <span className="bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] bg-clip-text text-transparent">
                        Seu ERP está operando, longe do ideal?
                    </span>
                </h2>
                <h3 className="font-inter-bold text-3xl md:text-4xl lg:text-5xl text-center text-white mb-12">
                    Nós assumimos.
                </h3>
                <p className="font-inter-light text-xl md:text-[32px] text-center max-w-5xl">
                    Com uma equipe especializada e atuação personalizada,
                    garantimos suporte de alto nível, planos sob medida e uma
                    entrega orientada para resultados.
                </p>
            </div>
        </div>
    );
}
